import { httpRequest } from "@/utils/HttpRequest";
import { IEvaluateFields, IEvaluateSearch, IEvaluateDetial } from "./evaluateTypes"
import { IMealPage } from "@/types/AppTypes";
class EvaluateService {
    async page(searchVo: IEvaluateSearch) {
        const apiUrl = "/evaluate/detailPage";
        return await httpRequest.post<IMealPage<IEvaluateDetial>>(apiUrl, searchVo);
    }
    async find(foodId: string) {
        const apiUrl = "/evaluate-detail/find";
        return await httpRequest.post<IMealPage<IEvaluateDetial>>(apiUrl, { foodId });
    }
    async insert(searchVo: IEvaluateDetial) {
        const apiUrl = "/common/food/insert";
        return await httpRequest.post<boolean>(apiUrl, searchVo);
    }
    async update(searchVo: IEvaluateDetial) {
        const apiUrl = "/common/food/update";
        return await httpRequest.post<boolean>(apiUrl, searchVo);
    }
    async remove(code: string) {
        const apiUrl = `/common/food/remove/${code}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    async import(code: string) {
        const apiUrl = `/common/food/import`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    async export(searchVo: IEvaluateDetial) {
        const apiUrl = `/common/food/export`;
        return await httpRequest.getFile(apiUrl);
    }
    //用户积分详情 分页
    async pointsPage(searchVo: any) {
        const apiUrl = "/points/page";
        return await httpRequest.post<IMealPage<any>>(apiUrl, searchVo);
    }
    //查询用户积分总数
    async pointsTotal(userId:string) {
        const apiUrl = `/points/findTotal/${userId}`;
        return await httpRequest.get<number>(apiUrl);
    }
    //查询厨师总评分
    async cookTotal(cookId:string) {
        const apiUrl = `evaluate/getGradeByCook/${cookId}`;
        return await httpRequest.get<number>(apiUrl);
    }
}
export const evaluateService = new EvaluateService();
